import { getApiUrl, fetchApiData, showOrHideClearButton } from '../shared/utils.js';
import { searchInputQueryParam, typeSearchDelay, searchButtonHiddenClass, hiddenClass, showClearAllButton, addClass, removeClass } from '../../../config.js';

export const clearFormExclusions = [searchInputQueryParam, 'region'];

export const fetchSectionResults = (section, elements, page, onPaginationUpdate, handleResponse, formDataParsing = {}) => {
    const { searchForm, resultsContainer } = elements;
    if (!searchForm || !resultsContainer) return;

    const url = getApiUrl(section, searchForm, formDataParsing);
    url.searchParams.set('pg', page);

    fetchApiData(
        url.toString(),
        (response) => {
            handleResponse(response, resultsContainer);
            if (onPaginationUpdate) onPaginationUpdate(response.meta.pagination);
        },
        () => {
            if (resultsContainer) {
                resultsContainer.innerHTML = `<p class="text-error">Error loading ${section} results. Please try again.</p>`;
            }
        }
    );
};

export const handleSectionResponse = (response, resultsContainer, noResultsContainer, templateId, populateCard) => {
    if (!resultsContainer || !noResultsContainer) return;

    if (!response.data.length) {
        addClass(resultsContainer, hiddenClass);
        removeClass(noResultsContainer, hiddenClass);
        return;
    }

    addClass(noResultsContainer, hiddenClass);
    removeClass(resultsContainer, hiddenClass);
    resultsContainer.innerHTML = '';

    const template = document.getElementById(templateId)?.content;

    response.data.forEach(item => {
        if (!template) return;

        const card = template.cloneNode(true);
        populateCard(card, item);
        resultsContainer.appendChild(card);
    });
};

export const bindSearchInput = (searchInput, resetAndFetch, clearSearchButton, searchButton) => {
    let typingTimer;

    if (!searchInput) return;

    searchInput.addEventListener('input', () => {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(() => {
            resetAndFetch();
        }, typeSearchDelay);

        if (clearSearchButton && searchButton) {
            if (searchInput.value) {
                clearSearchButton.classList.remove(searchButtonHiddenClass);
                searchButton.classList.add(searchButtonHiddenClass);
            } else {
                clearSearchButton.classList.add(searchButtonHiddenClass);
                searchButton.classList.remove(searchButtonHiddenClass);
            }
        }
    });

    if (!clearSearchButton || !searchButton) return;

    clearSearchButton.addEventListener('click', () => {
        searchInput.value = '';
        clearSearchButton.classList.add(searchButtonHiddenClass);
        searchButton.classList.remove(searchButtonHiddenClass);
        resetAndFetch();
    });
};

export const bindFormFields = (fields, resetAndFetch) => {
    fields.forEach(field => {
        field.addEventListener('change', () => {
            resetAndFetch();
        });
    });
};

export const bindFormSubmission = (searchForm, resetAndFetch) => {
    searchForm.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        resetAndFetch();
    });
};

export const bindClearAllButton = (clearAllButton, searchForm, resetAndFetch) => {
    showOrHideClearButton(clearAllButton, searchForm, clearFormExclusions);
    searchForm.addEventListener('change', () => showOrHideClearButton(clearAllButton, searchForm, clearFormExclusions));
    clearAllButton.addEventListener('click', () => {
        resetAndFetch();
        clearAllButton.classList.remove(showClearAllButton);

        const url = new URL(window.location);
        const keys = [...url.searchParams.keys()]
        keys.forEach((key) => {
            if (!clearFormExclusions.includes(key)) {
                url.searchParams.delete(key);
            }
        });

        history.pushState(null, '', url);
    });
};

export const resetAndFetchResults = (fetchResults, updateQueryString, searchForm) => {
    updateQueryString({ pg: 1 }); // Reset pagination to page 1
    updateQueryString(searchForm);
    fetchResults();
};
